import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CurrencyFormat from "react-currency-format";
import { useStateContext } from "../../../../context/StateContext_KO";
import { useTranslation } from "react-i18next";

const SubtotalCheckout = () => {
  const { t, i18n } = useTranslation();
  const {
    getBasketQuantity,
    getSubtotal,
    getShipping,
    getBasketTotal,
    taxPrice,
    shippingRate,
    freeshippingRate,
  } = useStateContext();
  const [subtotal, setSubtotal] = useState(getSubtotal());
  const [total, setTotal] = useState(getBasketTotal());

  useEffect(() => {
    setSubtotal(getSubtotal());
    setTotal(getBasketTotal());
  }, [getBasketTotal, getSubtotal]);

  useEffect(() => {
    console.log("getSubtotal()", getSubtotal());
    console.log("getShipping()", getShipping());
  }, [getShipping, getSubtotal]);

  return (
    <Box sx={{ py: 3 }}>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
          }}
        >
          <Box>
            {t("subtotal")} ({getBasketQuantity()}{" "}
            {getBasketQuantity() > 1 ? t("items") : t("item")}):
          </Box>

          <CurrencyFormat
            renderText={(subtotal) => <strong>{subtotal}</strong>}
            value={subtotal}
            displayType={"text"}
            thousandSeparator={true}
            suffix={"원"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("shipping")}:</Box>

          <Box>
            <strong>
              {+getSubtotal() < freeshippingRate ? (
                <CurrencyFormat
                  // renderText={(5) => <strong>{5}</strong>}
                  decimalScale={2}
                  value={shippingRate}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={"원"}
                />
              ) : (
                t("free_shipping")
              )}
            </strong>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("tax")}:</Box>
          <Box>
            <CurrencyFormat
              renderText={(taxPrice) => <strong>{taxPrice}</strong>}
              decimalScale={2}
              value={taxPrice}
              displayType={"text"}
              thousandSeparator={true}
              suffix={"원"}
            />
          </Box>
        </Box>
        <Box
          sx={{
            paddingTop: "10px",
            width: 1,
            borderBottom: "1px solid black",
            pb: 3,
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("total")}:</Box>
          <Box>
            {/* {subtotal < freeshippingRate ? (
              <CurrencyFormat
                renderText={(subtotal) => <strong>{subtotal}</strong>}
                decimalScale={2}
                value={getBasketTotal()}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"원"}
              />
            ) : ( */}
            <CurrencyFormat
              renderText={(subtotal) => <strong>{subtotal}</strong>}
              decimalScale={2}
              value={getBasketTotal()}
              displayType={"text"}
              thousandSeparator={true}
              suffix={"원"}
            />
            {/* )} */}
          </Box>
        </Box>

        {/* <FormControlLabel
							control={<Checkbox />}
							label="This order contains a gift"
						/> */}
        {/* <small>
							<input type="checkbox" /> This order contains a gift
						</small> */}
        {/* <Box sx={{ pt: 10 }}>
							<HashLink smooth to="/checkout">
								<Button
									variant="contained"
									sx={{
										width: 1,
										borderRadius: 0,
										backgroundColor: "black",
										py: 2,
									}}
								>
									Proceed to Checkout
								</Button>
							</HashLink>
						</Box> */}
      </>
      {/* )} decimalScale={2}
			value={value}
			displayType={"text"}
			thousandSeparator={true}
			prefix={"$"}
			// value={getBasketTotal(basket)}
			/> */}
    </Box>
  );
};

export default SubtotalCheckout;
